type LogContext = Record<string, unknown>;

const PREFIX = '[MatchRoom]';

function formatLine(message: string, context?: LogContext): string {
  return context ? `${PREFIX} ${message} ${JSON.stringify(context)}` : `${PREFIX} ${message}`;
}

function emit(level: 'log' | 'warn' | 'error', message: string, context?: LogContext) {
  const line = formatLine(message, context);
  if (level === 'error') {
    console.error(line);
    return;
  }
  if (level === 'warn') {
    console.warn(line);
    return;
  }
  console.log(line);
}

/** Unified debug logger — filter console by `[MatchRoom]`. */
export const matchroomLog = {
  boot() {
    emit('log', 'Logger active');
  },

  socket(message: string, context?: LogContext) {
    emit('log', `Socket ${message}`, context);
  },
  socketError(message: string, err?: unknown, context?: LogContext) {
    emit('error', `Socket ${message}`, {
      ...context,
      error: err instanceof Error ? { name: err.name, message: err.message } : err,
    });
  },

  room(message: string, context?: LogContext) {
    emit('log', `Room ${message}`, context);
  },

  participant(message: string, context?: LogContext) {
    emit('log', `Participant ${message}`, context);
  },

  capture(message: string, context?: LogContext) {
    emit('log', `Capture ${message}`, context);
  },

  publish(message: string, context?: LogContext) {
    emit('log', `Publish ${message}`, context);
  },

  signaling(message: string, context?: LogContext) {
    emit('log', `Signaling ${message}`, context);
  },

  ice(message: string, context?: LogContext) {
    emit('log', `ICE ${message}`, context);
  },

  peer(message: string, context?: LogContext) {
    emit('log', `Peer ${message}`, context);
  },

  track(message: string, context?: LogContext) {
    emit('log', `Track ${message}`, context);
  },

  render(message: string, context?: LogContext) {
    emit('log', `Render ${message}`, context);
  },

  permission(message: string, context?: LogContext) {
    emit('log', `Permission ${message}`, context);
  },

  warn(message: string, context?: LogContext) {
    emit('warn', message, context);
  },

  error(message: string, err?: unknown, context?: LogContext) {
    emit('error', message, {
      ...context,
      error: err instanceof Error ? { name: err.name, message: err.message } : err,
    });
  },
};
